import {
  TextWrapAroundIcon,
  TextWrapBoundingBoxIcon,
  TextWrapJumpIcon,
  TextWrapNoneIcon,
} from '@components/ui/custom-icons'
import { cn } from '@/utils'
import type { WrapStyle } from '@/lib/object-effects/types/wrap-style'
import { TooltipIconButton } from './tooltip-icon-button'

const WRAP_STYLE_OPTIONS = [
  { value: 'none' as const, label: 'No Wrap', Icon: TextWrapNoneIcon },
  { value: 'jump' as const, label: 'Jump', Icon: TextWrapJumpIcon },
  { value: 'wrap' as const, label: 'Wrap Shape', Icon: TextWrapAroundIcon },
  { value: 'boundingBox' as const, label: 'Bounding box', Icon: TextWrapBoundingBoxIcon },
]

interface WrapStyleButtonsProps {
  activeStyles: Set<WrapStyle>
  disabled: boolean
  /** True when exactly one target is selected — only then does clicking the active style
   *  toggle it back off to No Wrap. */
  singleTarget: boolean
  onApplyStyle: (style: WrapStyle) => void
}

export function WrapStyleButtons({
  activeStyles,
  disabled,
  singleTarget,
  onApplyStyle,
}: WrapStyleButtonsProps) {
  return (
    <div className="flex gap-2 mt-2">
      {WRAP_STYLE_OPTIONS.map(({ value, label, Icon }) => {
        const isActive = activeStyles.has(value)

        return (
          <TooltipIconButton
            key={value}
            tooltip={label}
            disabled={disabled}
            onClick={() => onApplyStyle(singleTarget && isActive ? 'none' : value)}
            aria-pressed={isActive}
            aria-label={label}
            className={cn('text-muted-foreground', isActive && 'bg-accent text-accent-foreground')}
          >
            <Icon className="h-4 w-4" aria-hidden />
          </TooltipIconButton>
        )
      })}
    </div>
  )
}
